import { render } from "./CatalogoEmpregado.vue?vue&type=template&id=0c02515d&ts=true"
import script from "./CatalogoEmpregado.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogoEmpregado.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src-next/modulos/estrutura-de-ponto-da-empresa/empregado/catalogo/apresentacao/CatalogoEmpregado.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c02515d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c02515d', __exports__)) {
    api.reload('0c02515d', __exports__)
  }
  
  module.hot.accept("./CatalogoEmpregado.vue?vue&type=template&id=0c02515d&ts=true", () => {
    api.rerender('0c02515d', render)
  })

}


export default __exports__